//
// ┌─────────────────────┐
// │ DO NOT EDIT BY HAND │
// └─────────────────────┘
//
// Generated by build.mjs in zinnia-icons
//
import { mapPropsToSvgProps, Props } from "../utils";
function IconNavVersionsFill(iconProps: Props) {
  const props = mapPropsToSvgProps(iconProps);
  return <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><rect x={4} y={6} width={16} height={2} fill="currentColor" /><rect x={5} y={2} width={14} height={2} fill="currentColor" /><rect x={3} y={10} width={18} height={12} fill="currentColor" /></svg>;
}
export default IconNavVersionsFill;